import React from 'react';
import { Popconfirm } from 'antd';
import { StarFilled, StarOutlined } from '@ant-design/icons';


const FavoriteStar = ({ id, isStarred, toggleFavorite }) => {
    return isStarred ? (
    <Popconfirm
      title="Are you sure you want to remove this from favorites?"
      onConfirm={() => toggleFavorite(id, false)}
      okText="Yes"
      cancelText="No"
    >
      <StarFilled style={{ color: 'var(--color-primary)', cursor: 'pointer', fontSize: '18px' }} />
    </Popconfirm>
  ) : (
    <Popconfirm
      title="Are you sure you want to add this to favorites?"
      onConfirm={() => toggleFavorite(id, true)}
      okText="Yes"
      cancelText="No"
    >
      <StarOutlined style={{ cursor: 'pointer', fontSize: '18px', color: '#B6C7D6' }} />
    </Popconfirm>
  );
}
export default FavoriteStar;